/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React, {MouseEventHandler} from 'react';
import {AwesomeIcon} from '@dvrd/dvr-controls';
import {BolmateButton} from '../controls';

interface Props {
    onClick: MouseEventHandler;
    className?: string;
}

export default function FeedbackButton(props: Props) {
    const {onClick, className} = props;

    return (
        <BolmateButton
            onClick={onClick}
            label={<AwesomeIcon name='lightbulb' prefix='far' />}
            tertiary
            color='notSet'
            iconOnly
            shape='square'
            className={className}
        />
    );
}
